const getTimeOrDate = (createdAt) => {
    // if the date is today, return the time
    // if the date is not today, return the date with date and month
    const today = new Date();
    const createdAtDate = new Date(createdAt);
    if (createdAtDate.toDateString() === today.toDateString()) {
        return createdAtDate.toLocaleTimeString('en-GB', { hour: 'numeric', minute: '2-digit', hour12: true });
    }
    return createdAtDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

export default getTimeOrDate;
